import styled from '@emotion/styled';

export const Subtitle = styled.p<{ centered: boolean }>`
  margin: ${(props) => (props.centered ? '0 auto' : '0')};
  font-size: 18px;
  max-width: 680px;
  padding: 15px 0;
`;
